
export default {
  props: {
    text: {type: String, default: ''},
    error: {type: Boolean, default: false},
  },
  computed: {
    html() {
      return this.text
        .replaceAll('\n', '<br/>')
        .replace(/\*{2}(.*?)\*{2}/g, '<b>$1</b>')
        .replace(/(\[([^\]]+)])\(([^)]+)\)/g, '<a href="$3" target="_blank">$2</a>')
    }
  }
}
